import { styled } from '@mui/material/styles';
import { Box, SpeedDial, SpeedDialAction } from '@mui/material';

export const LoadingBox = styled(Box)({
  width: "100%",
  height: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
});

export const NodeEditorContentBox = styled(Box)({
  width: "100%",
  height: "100%",
  flex: 1,
  margin: 0,
  padding: 0
});

export const ActionButtonsBox = styled(Box)<{ openSpeedDial?: boolean }>(({ openSpeedDial }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-end",
  alignItems: "flex-end",
  position: "absolute",
  bottom: "30px",
  right: "30px",
  zIndex: 1201, // drawer z-index is 1200
  height: openSpeedDial ? "auto" : "0px"
}));

export const StyledSpeedDial = styled(SpeedDial)({
  zIndex: 1201,
  position: 'relative'
});

export const StyledSpeedDialAction = styled(SpeedDialAction)({
  zIndex: 1201
}); 